import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnToggle(props) {
  let value = useDataValue({
    context: 'tab',
    path: 'selected.ledger.receivables.show_future_receivables',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.receivables.show_future_receivables',
    viewPath: props.viewPath,
  })
  return function onToggle() {
    change(!value)
  }
}
